
import { createReducer, on } from '@ngrx/store';
import { loadCashierRevenue, loadCashierRevenueError, loadCashierRevenueSuccess} from './cashier.actions';
import { ICashierRevenue } from 'src/app/shared/interfaces/cashier/revenue';

export interface ICashierRevenueState {
  list: ICashierRevenue[];
  isLoading: boolean
}

const initialState: ICashierRevenueState = {
  list: [],
  isLoading: false
};

export const cashierRevenueReducer = createReducer(
  initialState,
  on(loadCashierRevenue, (state) => ({
    ...state,
    isLoading: true
  })),
  on(loadCashierRevenueSuccess, (state, { list }) => ({
    ...state,
    list: [...list],
    isLoading: false
  })),
  on(loadCashierRevenueError, (state) => ({
    ...state,
    isLoading: false
  }))
);

